export enum WeatherAction {
  WEATHER_REQUEST = 'WEATHER_REQUEST',
  WEATHER_REQUEST_SUCCESS = 'WEATHER_REQUEST_SUCCESS',
  WEATHER_REQUEST_FAIL = 'WEATHER_REQUEST_FAIL',
}

export enum GeolocationAction {
  GEOLOCATION_REQUEST = 'GEOLOCATION_REQUEST',
  GEOLOCATION_REQUEST_SUCCESS = 'GEOLOCATION_REQUEST_SUCCESS',
  GEOLOCATION_REQUEST_FAIL = 'GEOLOCATION_REQUEST_FAIL',
}
